import { render } from "./UpdatePayment.vue?vue&type=template&id=52e4241c&scoped=true"
import script from "./UpdatePayment.vue?vue&type=script&lang=js"
export * from "./UpdatePayment.vue?vue&type=script&lang=js"

import "./UpdatePayment.vue?vue&type=style&index=0&id=52e4241c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./UpdatePayment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e4241c"]])

export default __exports__